import { Flex, Spacer } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { TopBar } from '@component/top_bar.component';
import { useResolveController, withNewContainer } from '@visiba/instantiation';
import { Async } from '@component/async.component';
import { ActionCard } from '@component/action_card.component';
import { Title } from '@component/title.component';
import { withTranslation } from '@application/i18n/with_translation';
import { ScreenRfvController } from './screen_rfv.controller';
import { ViewBookingAnalyticActions, ViewBookingController } from '../view_booking.controller';
import { useAnalyticContext } from '@application/analytic/analytic_link/mod';

export const ScreenRfv = withNewContainer(function ScreenRfv() {
	const viewBookingController = useResolveController(ViewBookingController);
	const controller = useResolveController(ScreenRfvController);
	const analytic = useAnalyticContext();

	function handleSelectReasonForVisit(reasonForVisitId: number) {
		return () => {
			analytic.trackEvent(ViewBookingAnalyticActions.SelectReasonForVisit, `${reasonForVisitId}`);
			controller.selectReasonForVisit(reasonForVisitId);
		};
	}

	return (
		<Flex gap={tokens.spacing.x1_5}>
			<TopBar.Content goBack />

			<Title
				title={withTranslation('View.Booking.ScreenRfv.Title')}
				titleSize='small'
				description={withTranslation('View.Booking.ScreenRfv.Description')}
			/>

			<Spacer vertical={tokens.spacing.x0_5} />

			<Async derive={viewBookingController.flowData}>
				{() => (
					<Flex gap={tokens.spacing.x1}>
						{viewBookingController.getFilteredReasonForVisits().map((reasonForVisit) => (
							<ActionCard.Root key={reasonForVisit.Id} onClick={handleSelectReasonForVisit(reasonForVisit.Id)}>
								<ActionCard.Title>{reasonForVisit.Name}</ActionCard.Title>
							</ActionCard.Root>
						))}
					</Flex>
				)}
			</Async>
		</Flex>
	);
});
